var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tab-view"},[_c('AppSystemInfoCard',{attrs:{"createdAt":_vm.carrier.createdAt,"updatedAt":_vm.carrier.updatedAt,"createdBy":_vm.carrier.createdBy.username,"updatedBy":_vm.carrier.lastModifiedBy.username}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }